/*
 * Kunde-faktura — storefront form handler.
 * Tre indgange, alle mundende ud i samme "invoice"-visning:
 *   1. Manuel formular: POSTer {order_number, email} til /api/public/invoice/request.
 *   2. ?ot=<shopify order token> (fra ordrebekræftelses-mailen): auto-POSTer
 *      {order_token} — ingen udfyldning nødvendig.
 *   3. ?token=<adgangs-token> (fra en tidligere faktura-mail, "Ret oplysninger"-
 *      knappen): GET'er direkte, springer anmodnings-trinnet helt over.
 * Mønster: assets/fortryd-ordre.js (inflight-guard, statusbeskeder, samme
 * fetch-stil uden custom headers — kun Content-Type/Accept, CORS-allowlistet).
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-faktura]');
  if (!root) return;

  var backend = root.getAttribute('data-backend') || '';
  var supportEmail = root.getAttribute('data-support-email') || 'kundeservice@jmdimensions.com';
  if (!backend) return;

  var requestView = root.querySelector('[data-faktura-view="request"]');
  var invoiceView = root.querySelector('[data-faktura-view="invoice"]');
  var requestForm = root.querySelector('[data-faktura-request-form]');
  var requestBtn = root.querySelector('[data-faktura-request-submit]');
  var billingForm = root.querySelector('[data-faktura-billing-form]');
  var billingBtn = root.querySelector('[data-faktura-billing-submit]');
  var msg = root.querySelector('[data-faktura-msg]');
  var downloadLink = root.querySelector('[data-faktura-download]');
  var orderNumberEl = root.querySelector('[data-faktura-order-number]');
  var orderMetaEl = root.querySelector('[data-faktura-order-meta]');
  if (!requestView || !invoiceView || !requestForm || !billingForm || !msg) return;

  var requestInflight = false;
  var billingInflight = false;
  var currentToken = null;

  function setMsg(text, type) {
    msg.textContent = text;
    msg.className = 'faktura-msg is-visible is-' + type;
  }
  function clearMsg() {
    msg.className = 'faktura-msg';
    msg.textContent = '';
  }
  function showView(name) {
    requestView.classList.toggle('is-active', name === 'request');
    invoiceView.classList.toggle('is-active', name === 'invoice');
  }
  function setRequestLoading(loading) {
    requestInflight = loading;
    requestBtn.disabled = loading;
  }
  function setBillingLoading(loading) {
    billingInflight = loading;
    billingBtn.disabled = loading;
  }

  function fmtMoney(n, currency) {
    try {
      return new Intl.NumberFormat('da-DK', { style: 'currency', currency: currency || 'DKK' }).format(n || 0);
    } catch (e) {
      return (n || 0) + ' ' + (currency || 'DKK');
    }
  }

  function fillBillingForm(billing) {
    if (!billing) return;
    var f = billingForm;
    f.querySelector('[name="company"]').value = billing.company || '';
    f.querySelector('[name="cvr"]').value = billing.cvr || '';
    f.querySelector('[name="name"]').value = billing.name || '';
    f.querySelector('[name="address1"]').value = billing.address1 || '';
    f.querySelector('[name="address2"]').value = billing.address2 || '';
    f.querySelector('[name="zip"]').value = billing.zip || '';
    f.querySelector('[name="city"]').value = billing.city || '';
    f.querySelector('[name="country"]').value = billing.country || 'Danmark';
  }

  function showInvoice(token, orderNumber) {
    currentToken = token;
    if (orderNumberEl) orderNumberEl.textContent = orderNumber || '';
    if (downloadLink) downloadLink.href = backend + '/api/public/invoice/' + encodeURIComponent(token) + '/pdf';

    // Skriv tokenet i URL'en så et gensyn (Ret oplysninger, genindlæsning) går direkte hertil.
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('token', token);
      url.searchParams.delete('ot');
      url.searchParams.delete('ordre');
      url.searchParams.delete('email');
      window.history.replaceState({}, '', url.toString());
    } catch (e) { /* ældre browsere — springer stille over */ }

    showView('invoice');
    clearMsg();

    // Hent ordre-opsummering + nuværende faktureringsoplysninger til formularen.
    fetch(backend + '/api/public/invoice/' + encodeURIComponent(token), {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (out) {
        var data = (out && out.data) || {};
        if (orderMetaEl) {
          var parts = [];
          if (data.total_price != null) parts.push(fmtMoney(data.total_price, data.currency));
          if (data.financial_status === 'paid') parts.push('Betalt');
          orderMetaEl.textContent = parts.join(' · ');
        }
        fillBillingForm(data.billing);
      })
      .catch(function () { /* download-linket virker stadig uden dette */ });
  }

  function requestByToken(orderToken) {
    setRequestLoading(true);
    setMsg('Henter din faktura…', 'info');
    fetch(backend + '/api/public/invoice/request', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ order_token: orderToken })
    })
      .then(function (res) { return res.json().then(function (data) { return { status: res.status, data: data }; }); })
      .then(function (out) {
        setRequestLoading(false);
        if (out.data && out.data.success && out.data.token) {
          showInvoice(out.data.token, out.data.order_number);
        } else {
          setMsg('Kunne ikke finde ordren automatisk — udfyld formularen nedenfor.', 'info');
        }
      })
      .catch(function () {
        setRequestLoading(false);
        setMsg('Der opstod en netværksfejl. Udfyld formularen nedenfor, eller kontakt os på ' + supportEmail + '.', 'error');
      });
  }

  requestForm.addEventListener('submit', function (e) {
    e.preventDefault();
    if (requestInflight) return;

    var orderNumber = (requestForm.querySelector('[name="order_number"]').value || '').trim();
    var email = (requestForm.querySelector('[name="email"]').value || '').trim();
    var website = (requestForm.querySelector('[name="website"]').value || '').trim();

    if (!orderNumber || !email) {
      setMsg('Udfyld venligst både ordrenummer og email.', 'error');
      return;
    }

    setRequestLoading(true);
    setMsg('Tjekker din ordre…', 'info');

    fetch(backend + '/api/public/invoice/request', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ order_number: orderNumber, email: email, website: website })
    })
      .then(function (res) {
        return res.json().then(function (data) { return { status: res.status, data: data }; })
          .catch(function () { return { status: res.status, data: {} }; });
      })
      .then(function (out) {
        setRequestLoading(false);
        var data = out.data || {};

        if (out.status === 429) {
          setMsg('For mange forsøg lige nu. Vent et øjeblik og prøv igen.', 'error');
          return;
        }

        if (data.success && data.token) {
          showInvoice(data.token, data.order_number);
          return;
        }

        setMsg(
          data.error || ('Vi kunne ikke finde din faktura. Kontakt os på ' + supportEmail + '.'),
          'error'
        );
      })
      .catch(function () {
        setRequestLoading(false);
        setMsg('Der opstod en netværksfejl. Tjek din forbindelse og prøv igen — eller kontakt os på ' + supportEmail + '.', 'error');
      });
  });

  billingForm.addEventListener('submit', function (e) {
    e.preventDefault();
    if (billingInflight || !currentToken) return;

    var payload = {
      company: billingForm.querySelector('[name="company"]').value.trim(),
      cvr: billingForm.querySelector('[name="cvr"]').value.trim(),
      name: billingForm.querySelector('[name="name"]').value.trim(),
      address1: billingForm.querySelector('[name="address1"]').value.trim(),
      address2: billingForm.querySelector('[name="address2"]').value.trim(),
      zip: billingForm.querySelector('[name="zip"]').value.trim(),
      city: billingForm.querySelector('[name="city"]').value.trim(),
      country: billingForm.querySelector('[name="country"]').value.trim()
    };

    if (!payload.name || !payload.address1 || !payload.zip || !payload.city) {
      setMsg('Navn, adresse, postnummer og by skal udfyldes.', 'error');
      return;
    }

    setBillingLoading(true);
    setMsg('Gemmer…', 'info');

    fetch(backend + '/api/public/invoice/' + encodeURIComponent(currentToken) + '/billing', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().then(function (data) { return { status: res.status, data: data }; })
          .catch(function () { return { status: res.status, data: {} }; });
      })
      .then(function (out) {
        setBillingLoading(false);
        if (out.status === 429) {
          setMsg('For mange forsøg lige nu. Vent et øjeblik og prøv igen.', 'error');
          return;
        }
        if (out.data && out.data.success) {
          setMsg('Gemt — din faktura er opdateret med de nye oplysninger.', 'success');
          return;
        }
        setMsg((out.data && out.data.error) || 'Kunne ikke gemme oplysningerne. Prøv igen.', 'error');
      })
      .catch(function () {
        setBillingLoading(false);
        setMsg('Der opstod en netværksfejl. Prøv igen om lidt.', 'error');
      });
  });

  // ── Indgange via query-parametre ──────────────────────────────────────────
  var params = new URLSearchParams(window.location.search);
  var qToken = params.get('token');
  var qOrderToken = params.get('ot');
  var qOrdre = params.get('ordre');
  var qEmail = params.get('email');

  if (qToken) {
    showInvoice(qToken, '');
  } else if (qOrderToken) {
    requestByToken(qOrderToken);
  } else if (qOrdre || qEmail) {
    if (qOrdre) requestForm.querySelector('[name="order_number"]').value = qOrdre;
    if (qEmail) requestForm.querySelector('[name="email"]').value = qEmail;
    // Begge kendt (fx link fra konto-ordrehistorik) → spring klikket over.
    if (qOrdre && qEmail) {
      requestForm.dispatchEvent(new Event('submit', { cancelable: true }));
    }
  }
})();
